import { FadeLoader } from 'react-spinners'
import React from 'react'
import * as StyledComponent from '../styles'
import * as ScrollViewControl from '../lib/scrollViewControl'

const preventBackgroundFromScrolling = open => {
  if (open) {
    ScrollViewControl.preventScrolling()
  } else {
    ScrollViewControl.allowScrolling()
  }
}

const SpinnerWithOverlay = (props, context) => {
  if (props.loading) {
    preventBackgroundFromScrolling(true)
  } else {
    preventBackgroundFromScrolling(false)
  }

  return props.loading
    ? <StyledComponent.SpinnerWithOverlay>
        <div className="spinner-backdrop">
          <div className='middle-spinner'>
            <FadeLoader key='loader' color={'#a3a3a3'} />
          </div>
        </div>
      </StyledComponent.SpinnerWithOverlay>
    : null
}
export default SpinnerWithOverlay



// WEBPACK FOOTER //
// ./src/components/SpinnerWithOverlay.js